import RichTextBoxViewModel from '@/ViewModels/Controls/RichTextBoxViewModel';
import CheckBoxViewModel from '@/ViewModels/Controls/CheckBoxViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import WindowViewModel from '@/ViewModels/Controls/WindowViewModel';
import ButtonViewModel from '@/ViewModels/Controls/ButtonViewModel';
import TextBoxViewModel from '@/ViewModels/Controls/TextBoxViewModel';
import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import WindowViewModelT from '@/ViewModels/Controls/WindowViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ButtonViewModelT from '@/ViewModels/Controls/ButtonViewModel';
import CheckBoxViewModelT from '@/ViewModels/Controls/CheckBoxViewModel';
import RichTextBoxViewModelT from '@/ViewModels/Controls/RichTextBoxViewModel';
import RADApplication from '@/Management/RADApplication';
import Config from '@/Management/GlobalConfiguration';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import ImageHandler from '@/Utility/ImageHandler';
import * as LocalizationHelper from '@/Utility/LocalizationHelper';
export default class MLStringRichInputBoxViewModel extends ControlViewModel {
    /**
     * Gibt an, ob der Text für alle Sprachen identisch ist
     */
    public isEachLanguageEqual: KnockoutObservable<boolean>;
    /**
     * Gibt an, ob der Text für alle Sprachen im Popup mit einem einzigen Control bearbeitet wird oder separat.
     */
    public window_isEachLanguageEqual: KnockoutObservable<boolean>;
    /**
     * Definiert den Separator-String
     */
    public separatorString: KnockoutObservable<string>;
    /**
     * Definiert den Separator-String
     */
    public ergName: string;
    /**
     * Das ViewModel für die RichTextBox
     */
    public richTextBox: RichTextBoxViewModel;
    public textbox: TextBoxViewModel;
    /**
     * Gibt die maximale Länge der Texte für die einzelnen Sprachen an
     */
    public maxLength: number;
    /**
     * Enthält das ViewModel für die im Popup-Fenster verwendete RichTextBoxViewModel
     */
    public window_richTextBox: RichTextBoxViewModel;
    /**
     * Das ViewModel für die Checkbox (PopUp)
     */
    public checkBox: CheckBoxViewModel;
    /**
     * Das ViewModel für das Label der RichTextboxEachLanguageEqual
     */
    public label: LabelViewModel;
    /**
     * Das ViewModel für den Link
     */
    public link: LinkViewModel;
    /**
     * Das ViewModel für das Window
     */
    public window: WindowViewModel;
    /**
     * Die angezeigten Buttons
     */
    public buttons: KnockoutObservable<ButtonViewModel>;
    /**
     * Setzt den Wert für alle Sprachen oder liest ihn aus
     */
    public value: any;
    /**
     * Funktion die nach der Initialisierung aufgerufen wird
     */
    public onAfterInit: Function;
    /**
     * Liste von ViewModels für jede Sprache
     */
    public groups: KnockoutComputed<Array<any>>;
    private LinkViewModel: any;
    private ImageViewModel: any;
    private WindowViewModel: any;
    private LabelViewModel: any;
    private ButtonViewModel: any;
    private CheckBoxViewModel: any;
    private RichTextBoxViewModel: any;
    /**
     * Ein internes Objekt zur Verwaltung der Eingaben
     */
    private languageDict: any;
    /** Wird beim Schließen des Fensters überprüft, um zu erfahren, ob die Daten übernommen werden sollen; wird bei OK oder Abbrechen gesetzt. */
    private acceptWindowValues: any;
    private language: any;
    private readDependency: any;
    constructor(params: any) {
        super(params);
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.WindowViewModel = ComponentManager.getViewModel<typeof WindowViewModelT>('WindowViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.ButtonViewModel = ComponentManager.getViewModel<typeof ButtonViewModelT>('ButtonViewModel');
        this.CheckBoxViewModel = ComponentManager.getViewModel<typeof CheckBoxViewModelT>('CheckBoxViewModel');
        this.RichTextBoxViewModel = ComponentManager.getViewModel<typeof RichTextBoxViewModelT>('RichTextBoxViewModel');
        this.languageDict = {};
        this.isEachLanguageEqual = this.observableOrDefault(params.isEachLanguageEqual, false);
        this.window_isEachLanguageEqual = this.observableOrDefault(this.isEachLanguageEqual());
        this.separatorString = this.observableOrDefault(params.separatorString, '');
        this.ergName = this.paramOrDefault(params.ergName, '');
        this.richTextBox = this.paramOrDefault(params.richTextBox, null);
        this.maxLength = this.paramOrDefault(params.maxLength, -1);
        this.onAfterInit = this.handlerOrDefault(params.onAfterInit);
        this.window_richTextBox = new this.RichTextBoxViewModel({
            parentLocator: this.locator,
            locator: 'window.value.all',
            isEnabled: this.isEnabled,
            isFocusable: this.isFocusable,
            maxLength: this.maxLength,
            onAfterInit: this.onAfterInit,
            window: new this.WindowViewModel({
                width: 1000,
                isModal: true,
                isOpen: false,
                allowClose: true,
                headline: new this.LabelViewModel({
                    caption: ''
                })
            })
        });
        this.checkBox = this.paramOrDefault(params.checkBox, (() => {
            return new this.CheckBoxViewModel({
                parentLocator: this.locator,
                locator: 'window.isEachLanguageEqual',
                isChecked: this.window_isEachLanguageEqual,
                isEnabled: this.isEnabled,
                label: new this.LabelViewModel({
                    parentLocator: this.locator,
                    locator: 'window.isEachLanguageEqual.label',
                    ergName: "FOR_ALL_LANGUAGE_EQUALS"
                })
            });
        })());
        this.label = this.paramOrDefault(params.label, (() => {
            return new this.LabelViewModel({
                parentLocator: this.locator,
                locator: 'value-label',
                ergName: this.ergName
            });
        })());
        this.link = this.paramOrDefault(params.link, (() => {
            return new this.LinkViewModel({
                parentLocator: this.locator,
                locator: 'button.open-dialog',
                tooltip: new this.LabelViewModel({
                    ergName: 'MLSTRING_CONFIGURATION_TOOLTIP'
                }),
                image: new this.ImageViewModel({
                    parentLocator: this.locator,
                    locator: 'button.open-dialog.image',
                    source: ImageHandler.buildSource(Config.inlineImages.MLSTRING_EDIT),
                    alternativeText: new this.LabelViewModel({
                        ergName: 'MLSTRING_CONFIGURATION_TOOLTIP'
                    })
                }),
                isFocusable: this.isFocusable,
                isToolBarLink: true,
                onClick: () => {
                    this.window.isOpen(true);
                }
            });
        })());
        this.acceptWindowValues = false;
        this.window = this.paramOrDefault(params.window, (() => {
            return new this.WindowViewModel({
                parentLocator: this.locator,
                locator: 'window',
                width: 800,
                isModal: true,
                isOpen: false,
                allowClose: false,
                headline: new this.LabelViewModel({
                    ergName: 'MULTILINGUAL_INPUT'
                }),
                // Daten in die Controls im Fenster kopieren
                onOpen: () => {
                    this.window_isEachLanguageEqual(this.isEachLanguageEqual());
                    this.window_richTextBox.value(this.richTextBox.value());
                    let groups = this.groups();
                    for (let i = 0; i < groups.length; i++) {
                        let group = groups[i];
                        group.richTextBox.value(group.liveValue());
                    }
                },
                // Daten aus den Controls im Fenster übernehmen
                onClose: () => {
                    if (!this.acceptWindowValues) return;
                    this.acceptWindowValues = false; // Falls das Fenster beim nächsten mal nicht über einen Button geschlossen wird, so soll nichts passieren; daher wird hier false gesetzt
                    this.isEachLanguageEqual(this.window_isEachLanguageEqual());
                    if (this.isEachLanguageEqual()) {
                        this.richTextBox.value(this.window_richTextBox.value());
                    }
                    else {
                        let groups = this.groups();
                        let currentLanguage = ResourceManager.getInstance().getLanguage().iso6391;
                        for (let i = 0; i < groups.length; i++) {
                            let group = groups[i];
                            // Wenn der Wert für die Sprache geändert wird, die auch in der TextBox verwendet wird, müssen wir diese ebenfalls aktualisieren
                            if (group.language == currentLanguage) {
                                this.setTextBoxValue(group.richTextBox.value());
                            }
                            group.liveValue(group.richTextBox.value());
                        }
                    }
                }
            });
        })());
        this.buttons = this.observableOrDefault(params.buttons, (() => {
            return [
                new this.ButtonViewModel({
                    parentLocator: this.locator,
                    locator: 'window.button.ok',
                    isPrimaryButton: true,
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: 'window.button.ok.image',
                        source: Config.inlineImages.WINDOW_OK,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'OKAY'
                        })
                    }),
                    label: new this.LabelViewModel({
                        parentLocator: this.locator,
                        locator: 'window.button.ok.label',
                        ergName: 'OKAY'
                    }),
                    onClick: () => {
                        this.acceptWindowValues = true;
                        this.window.isOpen(false);
                    }
                }),
                new this.ButtonViewModel({
                    parentLocator: this.locator,
                    locator: 'window.button.cancel',
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: 'window.button.cancel.image',
                        source: Config.inlineImages.WINDOW_CANCEL,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'CANCEL'
                        })
                    }),
                    label: new this.LabelViewModel({
                        parentLocator: this.locator,
                        locator: 'window.button.cancel.label',
                        ergName: 'CANCEL'
                    }),
                    onClick: () => {
                        this.acceptWindowValues = false;
                        this.window.isOpen(false);
                    }
                })
            ];
        })());
        // Die Language-Observables sollen hier schon erzeugt werden, damit Knockout die Abhängigkeit der Read-Methode
        // zu diesen erkennt; ansonsten würden sie nämlich erst in der read-Methode erzeugt werden und dort nicht als Abhängigkeit aufgenommen werden.
        // Dadurch wird this.value auch direkt aktualisiert, wenn sich einer der sprachspezifischen Werte ändert
        for (let i = 0; i < RADApplication.getInstance().configuration.languages.length; i++) {
            this.language = RADApplication.getInstance().configuration.languages[i];
            this.getLanguageObservable(this.language.iso6391);
        }
        // Dient dem Setzen des Wertes der Haupt-TextBox, ohne dass ggf. initiale null-Werte durch einen leeren String ersetzt werden,
        // was zu unerwünschten Benachrichtungen via dessen this.value-Observable führen würde
        // Damit wir beim Schreiben des Gesamtwertes via write nicht temporäre Werte an die Subscriber (insbesondere this.value selbst)
        // übermitteln, können wir hiermit die read-Methode temporär ausschalten und dann manuell triggern.
        this.readDependency = this.observableOrDefault(true).extend({ notify: 'always' });
        this.readDependency.allowRead = true;
        this.readDependency.cacheValue = null;
        this.value = this.defineComputed({
            read: () => {
                this.readDependency(); // Knockout die Abhängigkeit erkennen lassen, um sie triggern zu können
                let value = this.richTextBox.value();
                let isEachLanguageEqual = this.isEachLanguageEqual();
                let separatorString = this.separatorString();
                let result;
                if (isEachLanguageEqual === true) {
                    result = value;
                } else {
                    let parts = [];
                    for (let i = 0; i < RADApplication.getInstance().configuration.languages.length; i++) {
                        let language = RADApplication.getInstance().configuration.languages[i];
                        let langValue = this.getLanguageValue(language.iso6391);
                        if (langValue !== '')
                            parts.push(language.iso6391 + ':' + langValue);
                    }
                    if (parts.length === 0) {
                        result = '';
                    }
                    else {
                        result = separatorString + parts.join(separatorString);
                    }
                }
                if (!this.readDependency.allowRead) { // Ist das ein durch write/knockout INDIREKT getriggerter Aufruf? Wenn ja, dann noch alten Wert zurückgeben.
                    return this.readDependency.cacheValue;
                }
                this.readDependency.cacheValue = result; // Wert merken, um ihn in Schreibphasen zurückgeben zu können
                return result;
            },
            write: (value) => {
                value = value || '';
                let isEachLanguageEqual = this.isEachLanguageEqual();
                let separatorString = this.separatorString();
                if (isEachLanguageEqual === true) {
                    this.setTextBoxValue(value);
                    for (let i = 0; i < RADApplication.getInstance().configuration.languages.length; i++) {
                        let language = RADApplication.getInstance().configuration.languages[i];
                        this.setLanguageValue(value, language.iso6391);
                    }
                } else {
                    let languageValues = value.split(separatorString);
                    for (let i = languageValues.length - 1; i >= 0; i--) {
                        if (languageValues[i] == null || languageValues[i] === '') {
                            languageValues.splice(i, 1);
                        }
                    }
                    // Da read von den einzelnen Sprachwerten abhängt, schalten wir die Evaluierung hier temporär aus.
                    // Ansonsten würden schon durch das initiale Setzen den Subsribern von this.params.value falsche Werte
                    // übermittelt werden (dieses Observable wird mit this.params.value synchronisiert).
                    this.readDependency.allowRead = false;
                    for (let i = 0; i < languageValues.length; i++) {
                        let languageValue = languageValues[i]; // like: DE:example-text
                        let index = languageValue.indexOf(":");
                        let mlValue = languageValue.substring(index + 1, languageValue.length); // like: 'example-text'
                        let mlLang = languageValue.substring(0, index); // like: 'DE'
                        this.setLanguageValue(mlValue, mlLang);
                    }
                    // Die TextBox soll synchron mit dem Wert der aktuellen Sprache sein
                    let currentLanguage = ResourceManager.getInstance().getLanguage().iso6391;
                    let currentLanguageValue = this.getLanguageValue(currentLanguage);
                    this.setTextBoxValue(currentLanguageValue);
                    // Wert des Observables soll jetzt aktualisiert werden (in Knockout gespeichertes latestValue ist nicht automatisch der an write übergebene Wert!)
                    this.readDependency.allowRead = true;
                    this.readDependency(true);
                }
            }
        }, params.value);
        this.groups = this.defineComputed({
            read: () => {
                let result = [];
                // Beim Wechsel der aktuellen Sprache werden auch die ViewModels neu aufgebaut
                let currentLanguage = ResourceManager.getInstance().getLanguage().iso6391;
                // Die Abhängigkeit besteht nur zur Sprache; daher alle anderen Abhängigkeiten ausschalten:
                ko.ignoreDependencies(() => {
                    for (let i = 0; i < RADApplication.getInstance().configuration.languages.length; i++) {
                        let language = RADApplication.getInstance().configuration.languages[i];
                        let group = this.languageGroup(language);
                        result.push(group);
                    }
                });
                return result;
            },
            deferEvaluation: true
        });
        this.defineSubscription(this.richTextBox.value, (value) => {
            let isEachLanguageEqual = this.isEachLanguageEqual();
            if (isEachLanguageEqual === true) {
                for (let i = 0; i < RADApplication.getInstance().configuration.languages.length; i++) {
                    let language = RADApplication.getInstance().configuration.languages[i];
                    this.setLanguageValue(value, language.iso6391);
                }
            } else {
                let currentLanguage = ResourceManager.getInstance().getLanguage().iso6391;
                this.setLanguageValue(value, currentLanguage);
            }
        });
        ControlViewModel.checkProperties(this, params);
    }
    
    protected disposeInternal(): void {
        this.disposeObject(this.groups);
        super.disposeInternal();
    }
    
    public resetValue(): any {
        this.separatorString(null);
        this.value(null);
    }
    private setTextBoxValue(value: any): any {
        if (value == null) {
            value = '';
        }
        let currentValue = this.richTextBox.value();
        if (currentValue == null && value == '') {
            return;
        }
        this.richTextBox.value(value);
    }
    private languageGroup(language: any): any {
        return {
            language: language.iso6391,
            liveValue: this.getLanguageObservable(language.iso6391),
            label: new this.LabelViewModel({
                parentLocator: this.locator,
                locator: 'window.value.' + language.iso6391 + '.label',
                caption: LocalizationHelper.getLanguageFullName(language.iso6391)
            }),
            richTextBox: new this.RichTextBoxViewModel({
                parentLocator: this.locator,
                locator: 'window.value.' + language.iso6391,
                value: "", // Wert wird in this.window.onOpen von liveValue hier hin übertragen und in .onClose zurück
                maxLength: this.maxLength,
                isEnabled: this.isEnabled,
                window: new this.WindowViewModel({
                    width: 1000,
                    isModal: true,
                    isOpen: false,
                    allowClose: true,
                    headline: new this.LabelViewModel({
                        caption: ''
                    })
                }),
                language: language.iso6391,
                onAfterInit: this.onAfterInit
            }),
            image: new this.ImageViewModel({
                parentLocator: this.locator,
                locator: 'window.value.' + language.iso6391 + '.image',
                // Das vermeidet einen überflüssigen Request je Flagge; der Browser cached das Bild über die URL.
                source: ImageHandler.convertSource(language.iconUrl),
                isConvertedSource: true
            }),
            alternativeText: new this.LabelViewModel({
                ergName: 'RAD.RADFOUNDATION.PROBLEMDOMAIN.LOCALIZATION.LANGUAGE_FLAG_ERGNAME'
            })
        };
    }
    private getGroupInvalidText(language: any, maxLength: any): any {
        let groupInvalidationText = ResourceManager.getInstance().get('MLSTRING_LENGTH_CONSTRAINT');
        return groupInvalidationText.replace(/\$\$size\$\$/g, maxLength + '').replace(/\$\$language\$\$/g, language.fullName);
    }
    /**
     * Hilfsfunktion zum Setzen eines Sprachwerts
     */
    private setLanguageValue(value: any, iso6391: any): any {
        if (iso6391 in this.languageDict) {
            this.languageDict[iso6391](value);
        } else {
            this.languageDict[iso6391] = this.observableOrDefault(value);
        }
    }
    /**
     * Hilfsfunktion zum Auslesen eines Sprach-Observables
     */
    private getLanguageObservable(iso6391: any): any {
        if (iso6391 in this.languageDict) {
            return this.languageDict[iso6391];
        } else {
            let value = '';
            this.languageDict[iso6391] = this.observableOrDefault(value);
            return value;
        }
    }
    /**
     * Hilfsfunktion zum Auslesen eines Sprachwerts
     */
    private getLanguageValue(iso6391: any): any {
        if (iso6391 in this.languageDict) {
            return this.languageDict[iso6391]();
        } else {
            let value = '';
            this.languageDict[iso6391] = this.observableOrDefault(value);
            return value;
        }
    }
}

ComponentManager.setViewModel('MLStringRichInputBoxViewModel', MLStringRichInputBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');